
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('info_manage.center_change_request') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.year')"
                    label-for="registration_year"
                    >
                    <b-form-select
                    plain
                    v-model="search.registration_year"
                    :options="yearList"
                    id="year"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
             <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.month')"
                    label-for="registration_month"
                    >
                    <b-form-select
                    plain
                    v-model="search.registration_month"
                    :options="monthList"
                    id="registration_month"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="application_id"
              >
                <template v-slot:label>
                  {{ $t('info_manage.application_id')}}
                </template>
                <b-form-input
                    id="name"
                    v-model="search.application_id"
                    @change="loadData"
                ></b-form-input>
              </b-form-group>
            </b-col>
        </b-row>
         <b-row>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('info_manage.applicant_date')"
                    label-for="registration_date"
                    >
                    <b-form-input
                    class="date-picker"
                    v-model="search.registration_date"
                    id="registration_type"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-input>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  :label="$t('externalUser.disability_types')"
                  label-for="disable_type_id"
              >
                <b-form-select
                    plain
                    :options="disabilityTypeList"
                    v-model="search.disable_type_id"
                    id="registration_type"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
           <b-col xs="12" sm="12" md="4" lg="4" xl="4">
             <b-form-group
                 class="row"
                 label-cols-sm="4"
                 :label="$t('globalTrans.name')"
                 label-for="patient_id"
             >
               <b-form-select
                   plain
                   :options="patientList"
                   v-model="search.patient_id"
                   id="patient_id"
               >
                 <template v-slot:first>
                   <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                 </template>
               </b-form-select>
             </b-form-group>
           </b-col>
        </b-row>
        <b-row>
          <b-col lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="division_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('org_pro_division.division')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.division_id"
                    :options="divisionList"
                    id="division_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                    :disabled="activeCenter.division_id > 0"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="district_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{$t('org_pro_district.district')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.district_id"
                    :options="districtList"
                    id="district_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                    :disabled="activeCenter.district_id > 0"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col v-show="PauroshobaItemShow || UnionItemShow" lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="Upazila" vid="upazila_id">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="upazila_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{ $t('org_pro_upazilla.upazilla')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.upazila_id"
                    :options="upazilaList"
                    id="upazila_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col v-show="UnionItemShow" lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="Union" vid="union_id">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="union_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{ $t('org_pro_union.union')}}
                </template>
                <b-form-select
                    plain
                    v-model="search.union_id"
                    :options="unionList"
                    id="union_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col v-show="CityCorpItemShow" lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="City Corporation" vid="city_corporation_id">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="city_corporation_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{ $t('org_pro.city_corporation') }}
                </template>
                <b-form-select
                    plain
                    v-model="search.city_corporation_id"
                    :options="cityCorporationList"
                    id="city_corporation_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col v-show="PauroshobaItemShow" lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="Municipality" vid="paurasabha_id">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="paurasabha_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{ $t('org_pro.pauroshoba') }}
                </template>
                <b-form-select
                    plain
                    v-model="search.paurasabha_id"
                    :options="pauroshobaList"
                    id="paurasabha_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col v-show="ItemShow" lg="4" md="4" sm="4" xs="12">
            <ValidationProvider name="Ward" vid="ward_id">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="ward_id"
                  slot-scope="{ valid, errors }"
              >
                <template v-slot:label>
                  {{ $t('org_pro.ward') }}
                </template>
                <b-form-select
                    plain
                    v-model="search.ward_id"
                    :options="wardList"
                    id="ward_id"
                    :state="errors[0] ? false : (valid ? true : null)"
                >
                  <template v-slot:first>
                    <b-form-select-option value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col lg="4" md="4" sm="4" xs="12">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('info_manage.center_change_request')}} {{ $t('globalTrans.list') }}</h4>
            </template>
            <template v-slot:headerAction>
                <b-button variant="primary" v-b-modal.modal-7 @click="resetId">
                    {{  $t('globalTrans.add_new') }}
                </b-button>
            </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(application_id)="data">
                      {{ $n(data.item.application_id, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(registration_date)="data">
                      {{ data.item.registration_date|dateFormat }}
                    </template>
                    <template v-slot:cell(disability_types)="data">
                      {{ getDisabilityTypeNameList(data.item.disability_types) }}
                    </template>
                     <template v-slot:cell(status)="data">
                       <span class="badge badge-danger" v-if="data.item.status == 4">{{ $t('event_manage.rejected') }}</span>
                       <span class="badge badge-success" v-if="data.item.status == 3">{{ $t('globalTrans.approved') }}</span>
                       <span class="badge badge-primary" v-if="data.item.status == 2">{{ $t('event_manage.recommended') }}</span>
                       <span class="badge badge-warning" v-if="data.item.status == 1">{{ $t('event_manage.pending') }}</span>
                    </template>
                   <template v-slot:cell(action)="data">
                     <b-button  :title="$t('info_manage.patient_details')" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                     <b-button v-show="data.item.status == 1"  :title="$t('globalTrans.approve')" v-b-modal.modal-6 variant=" iq-bg-success border-info" size="sm" @click="approve(data.item)"><i class="ri-check-double-fill m-0"></i></b-button>
                     <b-button v-show="data.item.status == 1" :title="$t('event_manage.reject')" v-b-modal.modal-4 variant=" iq-bg-danger border-info" size="sm" @click="reject(data.item)"><i class="ri-close-circle-fill m-0 "></i></b-button>
                      <!-- <b-button title="Recommended" v-b-modal.modal-5 variant="iq-bg-info border-info" size="sm" @click="recommended(data.item)"><i class="fa fa-paper-plane" aria-hidden="true"></i></b-button> -->
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="xl" :title="$t('event_manage.registration_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <template #modal-title class="flex-grow-1">
         {{ $t('info_manage.patient_details') }}
          <b-button btn btn-primary @click="pdfExport" class="mr-2" style="margin-top:-4px;margin-left: 860px">
            {{  $t('globalTrans.export_pdf') }}
          </b-button>
      </template>
      <DetailModal :id="editItemId" :item="item" ref="details"/>
    </b-modal>
    <b-modal id="modal-4" size="lg" :title="$t('event_manage.reject')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Reject :id="rejectItemId" :item="item"/>
    </b-modal>
    <b-modal id="modal-5" size="lg" :title="$t('event_manage.forward')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Forward :id="recommendedItemId"  :item="item"/>
    </b-modal>
    <b-modal id="modal-6" size="lg" :title="$t('globalTrans.approve')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Approve :id="approveItemId"  :item="item"/>
    </b-modal>
    <b-modal id="modal-7" size="xl" :title="$t('globalTrans.approve')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <CenterChangeForm :item="item"/>
    </b-modal>
  </b-container>
</template>
<script>

import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { centerChangeRequestListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'
import custom from '@/store/custom'
import DetailModal from './DetailModal'
import Reject from './Reject'
import Forward from './Forward'
import Approve from './Approve'
import CenterChangeForm from './ChangeCenterForm'
import { helpers } from '@/mixins/helper-functions'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal,
    Reject,
    Forward,
    Approve,
    CenterChangeForm
  },
  data () {
    return {
      search: {
        registration_year: new Date().getFullYear(),
        registration_month: 0,
        application_id: '',
        registration_date: '',
        disable_type_id: 0,
        patient_id: 0,
        area_type_id: 0,
        city_corporation_id: 0,
        paurasabha_id: 0,
        division_id: 0,
        district_id: 0,
        upazila_id: 0,
        union_id: 0,
        ward_id: 0,
        center_id: 0
      },
      rows: [],
      editItemId: 0,
      item: '',
      data: [],
      rejectItemId: '',
      recommendedItemId: '',
      approveItemId: '',
      yearList: [],
      isRetailer: false,
      ItemShow: false,
      CityCorpItemShow: false,
      PauroshobaItemShow: false,
      UnionItemShow: false,
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: [],
      activeCenter: {
        value: 0,
        division_id: 0,
        district_id: 0
      }
    }
  },
  computed: {
     i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    },
    monthList: function () {
      return this.$store.state.commonObj.monthList
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    registrationTypeList: function () {
        return this.$store.state.ProductionService.commonObj.registrationTypeList
    },
    currentLocale () {
      return this.$i18n.locale
    },
    disabilityTypeList () {
      return this.$store.state.AwarenessEventService.commonObj.disabilityTypeList
    },
    patientList () {
      return this.$store.state.AwarenessEventService.commonObj.patientList
    },
    getAreaTypeList: function () {
      const objectData = custom.wardTypeList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    idscCenterList: function () {
        return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('info_manage.application_id'), class: 'text-center' },
          { label: this.$t('retailerManagement.name'), class: 'text-left' },
          { label: this.$t('externalUser.center'), class: 'text-center' },
          { label: this.$t('info_manage.applicant_date'), class: 'text-center' },
          { label: this.$t('globalTrans.division'), class: 'text-center' },
          { label: this.$t('globalTrans.district'), class: 'text-center' },
          { label: this.$t('event_manage.disable_type'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-left', thStyle: { width: '15%' } }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'application_id' },
          { key: 'name_bn' },
          { key: 'center_name_bn' },
          { key: 'registration_date' },
          { key: 'division_name_bn' },
          { key: 'district_name_bn' },
          { key: 'disability_types' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'application_id' },
          { key: 'name' },
          { key: 'center_name_en' },
          { key: 'registration_date' },
          { key: 'division_name' },
          { key: 'district_name' },
          { key: 'disability_types' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.fiscal_year_id': function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== 0) {
            this.fiscalYearDateRange(newVal)
          } else {
            this.search.fis_start_date = ''
            this.search.fis_end_date = ''
          }
        }
    },
    'search.division_id': function (newVal, oldVal) {
      this.districtList = this.getDistrictList(newVal)
    },
    'search.district_id': function (newVal, oldVal) {
      this.cityCorporationList = this.getCityCorporationList(newVal)
      this.upazilaList = this.getUpazilaList(newVal)
    },
    'search.upazila_id': function (newVal, oldVal) {
      this.unionList = this.getUnionList(newVal)
      this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    'search.city_corporation_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.paurasabha_id && !this.search.union_id) {
        this.wardList = this.getWardListByCityCorportaion(newVal)
      }
    },
    'search.paurasabha_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.city_corporation_id && !this.search.union_id) {
        this.wardList = this.getWardListByPauroshoba(newVal)
      }
    },
    'search.union_id': function (newVal, oldVal) {
      if (newVal !== oldVal && !this.search.paurasabha_id && !this.search.city_corporation_id) {
        this.wardList = this.getWardListByUnion(newVal)
      }
    }
  },
  created () {
    if (this.$store.state.dataFilters.officeId) {
      const centerOfficeId = this.$store.state.dataFilters.officeId
      this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
      this.search = Object.assign({}, this.search, {
          center_id: this.activeCenter.value,
          division_id: this.activeCenter.division_id,
          district_id: this.activeCenter.district_id
      })
    }
    this.loadData()
    this.getYearOptions()
  },
  mounted () {
    flatpickr('.date-picker', {})
  },
  methods: {
    fiscalYearDateRange (id) {
        const Date = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
        this.search.fis_start_date = Date.start_date
        this.search.fis_end_date = Date.end_date
    },
    details (item) {
      this.editItemId = item.id
      this.item = item
    },
    reject (item) {
      this.rejectItemId = item.id
      this.item = item
    },
    recommended (item) {
      this.recommendedItemId = item.id
    },
    approve (item) {
      this.approveItemId = item.id
      this.item = item
    },
    searchData () {
      this.loadData()
    },
    async loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      await RestApi.getData(awarenessEventServiceBaseUrl, centerChangeRequestListApi, params).then(response => {
          if (response.success) {
            this.data = this.getCustomDataList(response.data.data)
            this.$store.dispatch('setList', this.getCustomDataList(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getCustomDataList (data) {
      const listData = data.map(item => {
        const disabilities = JSON.parse(item.disability_types)
        const disabledTypeData = {}
        let disabledNameEn = ''
        let disabledNameBn = ''
        let count = 1
        const centerList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(type => type.value === parseInt(item.center_id))
        const canterData = {}
           if (typeof centerList !== 'undefined') {
              canterData.center_name_en = centerList.text_en
              canterData.center_name_bn = centerList.text_bn
          } else {
              canterData.center_name_en = ''
              canterData.center_name_bn = ''
          }
        disabilities.forEach(item => {
          const disabledTypeList = this.$store.state.HospitalDisabilityService.commonObj.disabilityTypesList.find(type => type.value === item)
          if (typeof disabledTypeList !== 'undefined') {
              if (count < (disabilities.length)) {
                disabledNameEn += disabledTypeList.text_en + ', '
                disabledNameBn += disabledTypeList.text_bn + ', '
              } else {
                disabledNameEn += disabledTypeList.text_en
                disabledNameBn += disabledTypeList.text_bn
              }
              count++
          }
        })
        disabledTypeData.disability_types = disabilities
        disabledTypeData.disabled_name_en = disabledNameEn
        disabledTypeData.disabled_name_bn = disabledNameBn
          const divisionList = this.$store.state.commonObj.divisionList.find(division => division.value === item.division_id)
          const divisonData = {}
           if (typeof divisionList !== 'undefined') {
              divisonData.division_name = divisionList.text_en
              divisonData.division_name_bn = divisionList.text_bn
          } else {
              divisonData.division_name = ''
              divisonData.division_name_bn = ''
          }
          const districtList = this.$store.state.commonObj.districtList.find(district => district.value === item.district_id)
          const districtData = {}
          if (typeof districtList !== 'undefined') {
            districtData.district_name = districtList.text_en
            districtData.district_name_bn = districtList.text_bn
          } else {
            districtData.district_name = ''
            districtData.district_name_bn = ''
          }
          return Object.assign({}, canterData, disabledTypeData, item, divisonData, districtData)
      })
      return listData
    },
    getYearOptions (startYear) {
      this.yearList = helpers.getYearList()
      return this.yearList
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
        this.CityCorpItemShow = true
        this.PauroshobaItemShow = false
        this.UnionItemShow = false
      } else if (typeId === 2) {
        this.CityCorpItemShow = false
        this.PauroshobaItemShow = true
        this.UnionItemShow = false
      } else if (typeId === 3) {
        this.CityCorpItemShow = false
        this.PauroshobaItemShow = false
        this.UnionItemShow = true
      }
    },
    getDistrictList (divisionId = null) {
      const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

      if (divisionId) {
        return districtList.filter(district => district.division_id === divisionId)
      }

      return districtList
    },
    getUpazilaList (districtId = null) {
      const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)

      if (districtId) {
        return upazilaList.filter(upazila => upazila.district_id === districtId)
      }

      return upazilaList
    },
    getUnionList (upazilaId = null) {
      const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
      if (upazilaId) {
        return unionList.filter(union => union.upazilla_id === upazilaId)
      }

      return unionList
    },
    getCityCorporationList (districtId) {
      const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getPauroshobaList (upazillaId = null) {
      const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
      if (upazillaId) {
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === parseInt(cityCorpId) && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByUnion (unionId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getDisabilityTypeNameList (disabilityTypes) {
      if (disabilityTypes) {
        const arr = []
        disabilityTypes = JSON.parse(disabilityTypes)
        disabilityTypes.forEach(item => {
            const disabilityType = this.disabilityTypeList.find(obj => obj.value === item)
            const disabilityTypeName = ' ' + (this.currentLocale === 'en' ? disabilityType.text_en : disabilityType.text_bn)
            arr.push(disabilityTypeName)
        })
        return arr.toString()
      }
      return disabilityTypes
    },
    pdfExport () {
      this.$refs.details.pdfExport()
    }
  }
}
</script>
<style>
.modal-title {
  flex-grow: 1 !important;
}
</style>
